<table class="participant-list-table">
  <thead>
    <tr>
      <th class="participant-list-header">
        {{ 'SHARED.PARTICIPANT_LIST.PARTICIPANTS' | translate }}
      </th>
      <th class="participant-list-header">
        {{ 'SHARED.PARTICIPANT_LIST.LAST_SEEN' | translate }}
      </th>
      <th class="participant-list-header unread-messages">
        {{ 'SHARED.PARTICIPANT_LIST.UNREAD' | translate }}
      </th>
      <th class="participant-list-header"></th>
    </tr>
  </thead>
  <tbody>
    @for (participant of participantsWithoutWorkflow(); track $index) {
      <tr
        shared-participant-list-item
        [participant]="participant"
        [user]="user()"
        data-testid="participant-list-item"
        [attr.data-test-value]="participant.id"
        (menuClicked)="menuClicked.emit($event)"></tr>
    }
  </tbody>
</table>
